export default __webpack_public_path__ + "alberta-chat-close.a9fbcd931768d49502bd.svg";